import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { StreetlightFaultsPage, StreetlightFaultsPageProps } from "./StreetlightFaultsPage";

export const EMPTY_PAGE_CONTENT: StreetlightFaultsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/streetlights";

export const StreetlightFaultsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<StreetlightFaultsPageProps>("streetlight_faults", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <StreetlightFaultsPage {...routeProps} {...content} />;
};
